export interface InviteUserPayload {
  Email: string;
}

export interface CopyScenarioPayload {
  ScenarioId: string | number;
  ScenarioName: string;
}

export interface CleanupDeletedUserPayload {
  JobId: string;
  DeletedUserId: number;
  DialogStatisticCount: number;
  ExternalGuestDeleted: boolean;
}

export interface CleanupDeletedUsersPayload {
  JobId: string;
  DeletedUserIds: number[];
  DeletedUserCount: number;
  DialogStatisticCount: number;
  ExternalGuestDeleteCount: number;
}

export interface FailurePayload {
  JobId: string;
  Message: string;
}

export interface NotificationPayloadMap {
  InviteUser: InviteUserPayload;
  CopyScenario: CopyScenarioPayload;
  CleanupDeletedUser: CleanupDeletedUserPayload;
  CleanupDeletedUsers: CleanupDeletedUsersPayload;
}

export type KnownTaskType = keyof NotificationPayloadMap;

/**
 * DTO sent from the Notifications SignalR hub.
 * For known task types, payload is strongly typed.
 * For unknown task types, payload remains unknown.
 */
export interface UserNotificationDto {
  jobId: string;
  taskType: string;
  status: 'Completed' | 'Failed' | string;
  payload: unknown;
}

export function isKnownTaskType(taskType: string): taskType is KnownTaskType {
  return (
    taskType in
    ({
      InviteUser: 1,
      CopyScenario: 1,
      CleanupDeletedUser: 1,
      CleanupDeletedUsers: 1
    } as Record<KnownTaskType, 1>)
  );
}

export function getTypedPayload<T extends KnownTaskType>(
  msg: UserNotificationDto & { taskType: T }
): NotificationPayloadMap[T] {
  return msg.payload as NotificationPayloadMap[T];
}
